import React, { useEffect } from "react";

import RydNoteDurationImage from "../widgets/RydNoteDurationImage";
import './DurationSelector.css';
import RydHeaderDialogBox from "../widgets/RydHeaderDialogBox";
import { NoteDuration } from "../../model/core";
import { useWorkspaceUIState } from "../../stores/WorkspaceStore";


const durations = ['WHOLE', 'HALF', 'QUARTER', 'EIGHTH', 'SIXTEENTH', 'THIRTY_SECOND']
    .map((backendName) => NoteDuration.fromBackendValue(backendName));

function NoteDurationSelector({
    duration,
    updateSelectedDuratonCB,
}: {
    duration?: NoteDuration,
    updateSelectedDuratonCB?: (duration: NoteDuration) => void,
}) {

    const [resolution, setResolution] = React.useState<NoteDuration>(duration ? duration : NoteDuration.fromBackendValue('QUARTER'));
    const workspaceUiState = useWorkspaceUIState();
    const [collapsed, setCollapsed] = React.useState(true);

    useEffect(() => {
        if (workspaceUiState.newNoteDuration && workspaceUiState.newNoteDuration.value !== resolution.value) {
            setResolution(workspaceUiState.newNoteDuration);
        }
    }, [workspaceUiState.newNoteDuration]);

    if (collapsed) {
        return (<button onClick={() => { setCollapsed(false) }}>Duration: {resolution.value}</button>);
    }

    return (<RydHeaderDialogBox closeCB={() => { setCollapsed(true) }}>
        <ul className="ryd--note-duration-selector">
            {durations.map((duration) =>
                <li className={resolution.value === duration.value ? 'ryd--note-duration-selector--active' : ''}
                    onClick={() => {
                        setResolution(duration);
                        updateSelectedDuratonCB?.(duration);
                        setCollapsed(true);
                    }}
                    key={duration.getDurationName()}>
                    <RydNoteDurationImage duration={duration} />
                </li>)}
        </ul>
    </RydHeaderDialogBox>);
}

export default NoteDurationSelector;